var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"focus:shadow-outline my-2",on:{"click":_vm.handleLogoClick}},[_c('Logo',{class:_vm.contain ? 'h-10 w-10' : 'max-h-full',style:({ maxWidth: _vm.contain ? '10rem' : '100%' }),attrs:{"alt":"LOGO.com"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }